<template>
  <div style="display: grid; grid-template-columns: repeat(2, 1fr); grid-template-rows: repeat(6, 1fr); column-gap: 0.75rem;">
    <b-form-group label-cols="4" label-align="right" label="Sub Total" style="grid-column: 1;">
      <b-input-group prepend="$" size="sm">
        <b-form-input disabled v-model="quote.subTotal" @change="formatNumber"/>
      </b-input-group>
    </b-form-group>

    <b-form-group label-cols="4" label-align="right" label="Charges" style="grid-column: 1;">
      <b-input-group prepend="$" size="sm">
        <b-form-input disabled v-model="quote.totalCharges" />
      </b-input-group>
    </b-form-group>

    <b-form-group label-cols="4" label-align="right" label="Shipping" style="grid-column: 1;">
      <b-input-group prepend="$" size="sm">
        <b-form-input type="number" v-model="quote.shippingCharge" @input="onShippingChange" />
      </b-input-group>
    </b-form-group>

    <b-form-checkbox class="ml-5" size="sm" switch v-model="quote.noChargeShipping" @input="onShippingChange">
      <span class="col-form-label">No Charge Shipping</span>
    </b-form-checkbox>

    <b-form-group label-cols="4" label-align="right" label="Total Credits" style="grid-column: 1;">
      <b-input-group prepend="$" size="sm">
        <b-form-input type="number" v-model="quote.shippingCharge" @input="onShippingChange" />
      </b-input-group>
    </b-form-group>

    <b-form-group label-cols="4" label-align="right" label="Tax / Vat" style="grid-column: 1;">
      <b-input-group prepend="$" size="sm">
        <b-form-input type="number" v-model="quote.shippingCharge" @input="onShippingChange" />
      </b-input-group>
    </b-form-group>
    
    <b-form-group label-cols="4" label-align="right" label="Total" style="grid-column: 1;">
      <b-input-group prepend="$" size="sm">
        <b-form-input disabled v-model="quote.total" />
      </b-input-group>
    </b-form-group>
  </div>
</template>

<script>

import debounce from 'lodash/debounce';
import { mapActions } from 'vuex';

const DEBOUNCE_TIME = 750;

export default {
  props: ['quote'],
  computed: {

  },
  mounted() {

  },
  methods: {
    ...mapActions('quotes', ['updateTotals']),
    formatNumber(value, event) {
      return Number(value).toLocaleString();
    },
     onShippingChange: debounce (async function() {
      if (! this.quote.shippingCharge) { 
         this.quote.shippingCharge = 0;
      } 
      let body = { shipping: this.quote.shippingCharge, noChargeShipping: this.quote.noChargeShipping };
      var result = await this.getTotals(body);
      this.$emit('updateTotal',result);
    
    },DEBOUNCE_TIME),
    async getTotals(body) {
      const result = await this.updateTotals([this.quote.id, body]);
      return result;
    }

  },

};
</script>